module.exports = __webpack_public_path__ + "img/522A1A_94543A_C3896F_AB7D66-256px.2acf0f53.png";